<div class="tab-pane" role="tabpanel" id="otras_solicitudes">
    <fieldset id="agregar_otras_solicitudes" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Otras Solicitudes</strong></h3>
                        <div><label>(Que acompañan la presente solicutud)</label></div>
                        <hr />
                        <div class="form-horizontal">
                            <div class="form-group col-md-12" align="left" style="padding-bottom: 15px"><label>Tramitacion Conjunta</label></div>
                            
                            <div class="form-group col-md-12" align="left">
                                <div>
                                    <mat-checkbox id="tramitacion_conj1" name="tramitacion_conj1" formControlName="tramitacion_conj1" (change)="add_otras_solicitudes()" value="SI">Demolicion</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group col-md-12" align="left">
                                <div>
                                    <mat-checkbox id="tramitacion_conj2" name="tramitacion_conj2" formControlName="tramitacion_conj2" (change)="add_otras_solicitudes()" value="SI">Instalacion de Gruas y Similares</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group col-md-12" align="left ">
                                <div>
                                    <mat-checkbox id="tramitacion_conj3" name="tramitacion_conj3" formControlName="tramitacion_conj3" (change)="add_otras_solicitudes()" value="SI">Instalacion de Faenas</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group col-md-12" align="left ">
                                <div>
                                    <mat-checkbox id="tramitacion_conj4" name="tramitacion_conj4" formControlName="tramitacion_conj4" (change)="add_otras_solicitudes()" value="SI">Ejecuci&oacute;n de excavaciones, Entibaciones y Socalados </mat-checkbox>
                                </div>
                            </div>
                            <div class="col-md-2"></div>
                            <div class="form-group col-md-10 grupo" align="left" style="padding-top: 0px">
                                <div class="col-md-3 fusion">
                                    <mat-checkbox id="fusion" name="fusion" formControlName="fusion" (change)="add_otras_solicitudes()" value="SI">Fusion</mat-checkbox>
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label" style=" padding-top: 15px; text-align:left" for="solicitud_fusion">Solicitud</label>
                                </div>
                                <div class="col-md-2" style="margin-left: -30px;">
                                    <mat-form-field class="example-full-width" style="width: 120px;">
                                        <input matInput placeholder="Solicitud Fusion" id="solicitud_fusion" name="solicitud_fusion" formControlName="solicitud_fusion" (change)="add_otras_solicitudes()" >
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label" style=" padding-top: 15px; text-align:left ;margin-left: 20px;" for="fecha_fusion">Fecha</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="dateinput" style="width: 120px; margin-left: -20px;">
                                        <input matInput [matDatepicker]="dp2" [max]="maxDate" formControlName="fecha_fusion" disabled (dateInput)="add_otras_solicitudes($event, 'input')" (dateChange)="add_otras_solicitudes($event, 'change')">
                                        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                                        <mat-datepicker #dp2 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-md-2"></div>
                            <div class="form-group col-md-10 grupo" align="left" style="padding-top: 0px">
                                <div class="col-md-3 fusion">
                                    <mat-checkbox id="cambio" name="cambio" formControlName="cambio" (change)="add_otras_solicitudes()" value="SI">Cambio de Destino</mat-checkbox>
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label" style=" padding-top: 15px; text-align:left" for="solicitud_cambio">Solicitud</label>
                                </div>
                                <div class="col-md-2"  style="margin-left: -30px;">
                                    <mat-form-field class="example-full-width" style="width: 120px;">
                                        <input matInput placeholder="Solicitud Cambio" id="solicitud_cambio" name="solicitud_cambio" formControlName="solicitud_cambio" (change)="add_otras_solicitudes()" >
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label" style=" padding-top: 15px; text-align:left ;margin-left: 20px;" for="fecha_cambio">Fecha</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="dateinput" style="width: 120px; margin-left: -20px;">
                                        <input matInput [matDatepicker]="dp3" [max]="maxDate" formControlName="fecha_cambio" (dateInput)="add_otras_solicitudes($event, 'input')" (dateChange)="add_otras_solicitudes($event, 'change')">
                                        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                                        <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group col-md-12" align="left" style="padding-bottom: 20px">
                                <div>
                                    <mat-checkbox id="otras" name="otras" formControlName="otras" (change)="add_otras_solicitudes()" value="SI">Otras</mat-checkbox>
                                </div>

                            </div>
                            <br />
                            <div class="form-group col-md-12" align="left" style="padding-bottom: 15px"><label>Tramitacion Simult&aacute;nea</label></div>\
                            <hr />
                            <div class="col-md-2"></div>
                            <div class="form-group col-md-10 grupo" align="left">
                                <div class="col-md-3">
                                    <mat-checkbox id="loteo" name="loteo" formControlName="loteo" (change)="add_otras_solicitudes()" value="SI">Loteo</mat-checkbox>
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label" style=" padding-top: 15px; text-align:left" for="solicitud_fusion">Solicitud</label>
                                </div>
                                <div class="col-md-2"  style="margin-left: -30px;">
                                    <mat-form-field class="example-full-width" style="width: 120px;" (change)="add_otras_solicitudes()">
                                        <input matInput placeholder="Solicitud Loteo" id="solicitud_loteo" name="solicitud_loteo" formControlName="solicitud_loteo" (change)="add_otras_solicitudes()">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label"  style=" padding-top: 15px; text-align:left ;margin-left: 20px;" for="fecha_loteo">Fecha</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="dateinput" style="width: 120px; margin-left: -20px;" >
                                        <input matInput [matDatepicker]="dp4" [max]="maxDate" formControlName="fecha_loteo" disabled (dateInput)="add_otras_solicitudes($event, 'input')" (dateChange)="add_otras_solicitudes($event, 'change')">
                                        <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
                                        <mat-datepicker #dp4 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>